require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-india-study-yoga.json") })
        }
      }, "path---blog-india-study-yoga");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-india-study-yoga!./.cache/json/blog-india-study-yoga.json
// module id = 293
// module chunks = 231608221292675